/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {CollectionModelWorkflowDTO} from '../model/collectionModelWorkflowDTO';
import {EntityModelWorkflowDTO} from '../model/entityModelWorkflowDTO';
import {InlineResponse200} from '../model/inlineResponse200';
import {Pageable} from '../model/pageable';
import {WorkflowDTO} from '../model/workflowDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {SelectGenerictemDTO} from "../model/selectGenerictemDTO";


@Injectable()
export class ConfiguratorWorkflowService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer ou mettre à jour un workflow
     * Cette requête permet de créer un workflow.&lt;br&gt;Si l&#x27;opération réussit, le workflow est renvoyé avec un code 201 (Created).&lt;br&gt;Si l&#x27;opération échoue, un message d&#x27;erreur est renvoyé avec un code 400 (Bad Request).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au tenant/datastore.
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrUpdateWorkflow(body: WorkflowDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDTO>;
    public createOrUpdateWorkflow(body: WorkflowDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDTO>>;
    public createOrUpdateWorkflow(body: WorkflowDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDTO>>;
    public createOrUpdateWorkflow(body: WorkflowDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createOrUpdateWorkflow.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createOrUpdateWorkflow.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDTO>('post',`${this.basePath}/api/workflows`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un workflow par son identifiant
     * Cette requête permet de supprimer un workflow par son identifiant.&lt;br&gt;Si l&#x27;opération réussit, le workflow est supprimé avec un code 204 (NO_CONTENT).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au tenant/datastore.
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWorkflow(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteWorkflow(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteWorkflow(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteWorkflow(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteWorkflow.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWorkflow.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/workflows/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tous les workflows
     * Cette requête permet de lister tous les workflows.&lt;br&gt;Si l&#x27;opération réussit, les workflows sont renvoyés avec un code 200 (OK).&lt;br&gt;Si l&#x27;opération échoue, un message d&#x27;erreur est renvoyé avec un code 400 (Bad Request).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au tenant/datastore.&lt;br&gt;La réponse de la requête est paginée.
     * @param xDataStoreID
     * @param pageable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllWorkflows(xDataStoreID: string, pageable: Pageable, observe?: 'body', reportProgress?: boolean): Observable<CollectionModelWorkflowDTO>;
    public getAllWorkflows(xDataStoreID: string, pageable: Pageable, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CollectionModelWorkflowDTO>>;
    public getAllWorkflows(xDataStoreID: string, pageable: Pageable, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CollectionModelWorkflowDTO>>;
    public getAllWorkflows(xDataStoreID: string, pageable: Pageable, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllWorkflows.');
        }

        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getAllWorkflows.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pageable !== undefined && pageable !== null) {
            queryParameters = queryParameters.set('pageable', <any>pageable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/hal+json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CollectionModelWorkflowDTO>('get',`${this.basePath}/api/workflows`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param X_PARTNER_ID
     * @param entity
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getItemProcess(xDataStoreID: string, X_PARTNER_ID: string, entity: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public getItemProcess(xDataStoreID: string, X_PARTNER_ID: string, entity: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public getItemProcess(xDataStoreID: string, X_PARTNER_ID: string, entity: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public getItemProcess(xDataStoreID: string, X_PARTNER_ID: string, entity: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getItemProcess.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling getItemProcess.');
        }

        if (entity === null || entity === undefined) {
            throw new Error('Required parameter entity was null or undefined when calling getItemProcess.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getItemProcess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (entity !== undefined && entity !== null) {
            queryParameters = queryParameters.set('entity', <any>entity);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InlineResponse200>('get',`${this.basePath}/api/workflow/process/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListProcess(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: Array<SelectGenerictemDTO>; }>;
    public getListProcess(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: Array<SelectGenerictemDTO>; }>>;
    public getListProcess(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: Array<SelectGenerictemDTO>; }>>;
    public getListProcess(xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getListProcess.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: Array<SelectGenerictemDTO>; }>('get',`${this.basePath}/api/workflow/process/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un workflow par son identifiant
     * Cette requête permet de récupérer un workflow par son identifiant.&lt;br&gt;Si l&#x27;opération réussit, le workflow est renvoyé avec un code 200 (OK).&lt;br&gt;Si l&#x27;identifiant fourni ne correspond à aucun workflow, un message d&#x27;erreur est renvoyé avec un code 404 (Not Found).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au tenant/datastore.
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWorkflow(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EntityModelWorkflowDTO>;
    public getWorkflow(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EntityModelWorkflowDTO>>;
    public getWorkflow(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EntityModelWorkflowDTO>>;
    public getWorkflow(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getWorkflow.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getWorkflow.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/hal+json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EntityModelWorkflowDTO>('get',`${this.basePath}/api/workflows/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Démarrer un workflow
     * Cette requête permet de démarrer un workflow.&lt;br&gt;Si l&#x27;opération réussit, le workflow est démarré avec un code 200 (OK).&lt;br&gt;Si l&#x27;identifiant fourni ne correspond à aucun workflow, un message d&#x27;erreur est renvoyé avec un code 404 (Not Found).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; Le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au tenant/datastore.
     * @param xDataStoreID
     * @param id
     * @param date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public start(xDataStoreID: string, id: string, date?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public start(xDataStoreID: string, id: string, date?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public start(xDataStoreID: string, id: string, date?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public start(xDataStoreID: string, id: string, date?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling start.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling start.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/workflows/${encodeURIComponent(String(id))}/start`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter un workflow au format JSON
     * Cette requête permet d'exporter un workflow au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportWorkflowJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportWorkflowJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportWorkflowJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportWorkflowJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportWorkflowJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportWorkflowJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/workflows/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs workflows au format ZIP
     * Cette requête permet d'exporter plusieurs workflows dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportWorkflowsZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportWorkflowsZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportWorkflowsZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportWorkflowsZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportWorkflowsZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportWorkflowsZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/workflows/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer un workflow depuis JSON
     * Cette requête permet d'importer un workflow depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importWorkflowJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDTO>;
    public importWorkflowJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDTO>>;
    public importWorkflowJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDTO>>;
    public importWorkflowJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importWorkflowJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importWorkflowJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<WorkflowDTO>('post',`${this.basePath}/api/workflows/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs workflows depuis ZIP
     * Cette requête permet d'importer plusieurs workflows depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importWorkflowsZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<WorkflowDTO>>;
    public importWorkflowsZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WorkflowDTO>>>;
    public importWorkflowsZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WorkflowDTO>>>;
    public importWorkflowsZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importWorkflowsZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importWorkflowsZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<WorkflowDTO>>('post',`${this.basePath}/api/workflows/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
